import LinkedMemberForm from '../../../../components/Main/Group/LinkedMember/LinkedMemberForm'
import React from 'react'
import { Modal } from 'antd'
import FooterButtons from '../../../../elements/Buttons/FooterButtons'

function LinkedMemberModal(props) {
  const {
    remove,
    submit,
    update,
    visible,
    modalType,
    formRef,
    onCancel,
    removing,
    submitting,
  } = props
  const isNew = modalType === 'new'
  return (
    <Modal
      visible={visible}
      title={'Role'}
      onCancel={onCancel}
      destroyOnClose={true}
      footer={
        <FooterButtons
          submit={submit}
          remove={remove}
          removing={removing}
          submitting={submitting}
          title={'Role'}
          isNew={isNew}
          isEdit={!isNew}
        />
      }
      width={'75%'}>
      <LinkedMemberForm ref={formRef} {...props} />
    </Modal>
  )
}

LinkedMemberModal.propTypes = {}
LinkedMemberModal.defaultProps = {}

export default LinkedMemberModal
